import React, { useEffect, useMemo, useState } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Modal } from 'antd';

import SetPwd from './FormSetPwd';
// import { onCloseLoginModal } from "../utils"

import './index.less';

import { event } from '../event';
import customLocalStorgeEventListener from '../utils/timeout';

const SetPwdApp = (props: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  useState(() => {
    event.on('event-showPwdModal', setIsModalOpen);
  });

  useEffect(() => {
    customLocalStorgeEventListener('aminerSetPwdStatus', ({ value: status }) => {
      // 关闭回调
      setIsModalOpen(status);
      // 关闭回调用
      if (status == false && props.onClose) {
        props.onClose();
      }
    });
  }, []);

  return (
    <Modal
      maskClosable={false}
      width={props?.width || 480}
      destroyOnClose={true}
      centered={true}
      closable={false}
      open={isModalOpen}
      wrapClassName={'loginModalWrap'}
      footer={null}
      title={
        <div className={'loginHeader'}>
          <div>{/*<ArrowLeftOutlined className={'closeIcon'} />*/}</div>
          <div className={'closeIcon'} onClick={() => setIsModalOpen(false)}>
            <CloseOutlined />
          </div>
        </div>
      }
    >
      <SetPwd isUpdStatus={true} {...props} onClose={() => setIsModalOpen(false)} />
    </Modal>
  );
};

export default SetPwdApp;
